/*
 *
 *  * *****************************************************************************
 *  *  Copyright (C) 2020 Testsigma Technologies Inc.
 *  *  All rights reserved.
 *  *  ****************************************************************************
 *
 */
export enum RestCompareType {
  STRICT = "STRICT",
  LENIENT = "LENIENT",
  NON_EXTENSIBLE = "NON_EXTENSIBLE",
  STRICT_ORDER = "STRICT_ORDER",
  JSON_SCHEMA = "JSON_SCHEMA",
  JSON_PATH = "JSON_PATH"
}
